<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="clearingManagement.pkid > 0 ? '编辑':'新建'"
      width="1000px"
      top="10vh"
      @close="$reset('form')">
    <div>
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="clearingManagement"
          :rules="ruleValidate"
          class="form"
          style="width: 365px;"
          label-width="100px">
        <el-form-item label="编号">
          <el-input v-model="clearingManagement.no" disabled style="width: 100%" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="清账日期">
          <el-date-picker
              v-model="clearingManagement.clearAccountDate"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              style="width: 265px"
              placeholder="选择日期"/>
        </el-form-item>
      </el-form>
      <div>
        <div slot="toolbar">
          <el-button type="primary" style="margin-bottom: 3%" @click="$refs.editCollectionRecordPage.open(10)">
            添加收款
          </el-button>
          <el-button type="primary" style="margin-bottom: 3%" @click="$refs.editInvoiceApplicationPage.open(20)">
            添加开票
          </el-button>
        </div>
        <el-table
            height="39vh"
            :data="tableData">
          <el-table-column align="center" label="行号" prop="rowIndex"/>
          <el-table-column align="center" label="开票凭证" prop="invoiceNo"/>
          <el-table-column align="center" label="凭证号" prop="fiNo"/>
          <el-table-column align="center" label="凭证类型" prop="fiType">
            <template slot-scope="scope">
              <span v-if="scope.row.fiType === 10">收款单</span>
              <span v-if="scope.row.fiType === 20">开票单</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="发货单" prop="deliveryBillNo"/>
          <el-table-column align="center" label="销售订单" prop="salesOrderNo"/>
          <el-table-column align="center" label="金额" prop="amount"/>
          <el-table-column align="center" label="状态" prop="status">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">待处理</span>
              <span v-else-if="scope.row.status === 10">处理中</span>
              <span v-else-if="scope.row.status === 20">已处理</span>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              align="center"
              class-name="vm-table_operate"
              width="120px">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status === 0" type="danger" @click="oneDelete(scope.$index,scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <clearing-management-details1 ref="editCollectionRecordPage" @select="getList"/>
        <clearing-management-details2 ref="editInvoiceApplicationPage" @select="getList"/>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import constant from "@/util/constant";
  import ClearingManagementDetails1 from "@/views/invoicingManagement/clearingManagement/ClearingManagementDetails1";
  import ClearingManagementDetails2 from "@/views/invoicingManagement/clearingManagement/ClearingManagementDetails2";
  export default {
    name: "ClearingManagementEdit",
    components: {ClearingManagementDetails1, ClearingManagementDetails2},
    data() {
      return {
        constant,
        snTypes: constant.toSelect(constant.snType),
        snStatus: constant.toSelect(constant.snStatus),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        clearingManagement: {
          pkid: "",
          no: "",
          clearAccountDate: "",
          details:[],
        },
        deleteIds:[],
        tableData:[],
        ruleValidate: {
          // clearingManagementNo: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.clearingManagement.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }else {
          this.getNo();
        }
      },
      getData() {
        this.$http
          .get("basic", `clearAccount/${this.clearingManagement.pkid}`)
          .then(resp => {
            console.log(resp);
            this.clearingManagement = resp;
            this.tableData = this.clearingManagement.details;
          });
      },
      getNo() {
        this.$http
          .get("basic", "clearAccount/getNo")
          .then(resp => {
            this.clearingManagement.no = resp;
          });
      },
      getList(row,fiType) {
        console.log(row.details);
        if (fiType === 10) {
          this.tableData.push({
            pkid: 0,
            rowIndex: row.rowIndex,
            masterId: row.pkId,
            fiType: fiType,
            fiNo: row.financialDocNo,
            status: 0,
            amount: row.amount,
          });
        }else {
          for (let item of  row.details) {
            this.tableData.push(
              {
                pkid: 0,
                status: 0,
                masterId: row.pkId,
                fiType: fiType,
                invoiceNo: row.invoiceNo,
                fiNo: item.fiNo,
                amount: item.netPrice + item.taxPrice,
                deliveryBillNo: item.sapDeliveryBillNo,
                rowIndex: item.sapDeliveryBillRowIndex,
                salesOrderNo:item.sapSalesOrderNo,
              }
            );
          }

        }

      },
      //详情表删除
      oneDelete(index) {
        this.tableData.splice(index,1);
        //使tableData重新排序
        this.tableData.forEach((item,index) => {
          item.rowIndex = index+1;
        });
      },

      handleSubmit() {
        this.clearingManagement.details = this.tableData;
        console.log(this.clearingManagement);
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic","clearAccount",this.clearingManagement)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .el-dialog .el-dialog__body{
    padding: 0;
  }
</style>
